/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

/* global
  GA_TRACKING_CODE: false,
  GA_TRACKING_CONFIG: false
*/
/* Execute on all pages. */

import {install as installLogging} from "logging";

installLogging();

import {__} from "language";
import {oneLineTrim} from "common-tags";

require(`tenants/${__TENANT_ID__}/styles.less`);

if (__PROD__) {
  // Install Full Story user session logging.
  window["_fs_debug"] = false;
  window["_fs_host"] = "fullstory.com";
  window["_fs_org"] = "5G74M";
  window["_fs_namespace"] = "FS";

  (function(m, n, e, t, l, o, g, y){
      if (e in m && m.console && m.console.log) {
        m.console.log(
          `FullStory namespace conflict. Please set window["_fs_namespace"].`,
        );

        return;
      }

      g = m[e] = function(a, b) {
        g.q ? g.q.push([a, b]) : g._api(a,b);
      };

      g.q = [];
      o = n.createElement(t);
      o.async = 1;
      o.src = `https://${_fs_host}/s/fs.js`;
      y = n.getElementsByTagName(t)[0];
      y.parentNode.insertBefore(o,y);

      g.identify = function(i, v) {
        g(l, {uid:i});

        if (v) {
          g(l, v);
        }
      };

      g.setUserVars = function(v) {
        g(l,v);
      };

      g.identifyAccount = function(i, v) {
        o = "account";
        v = v || {};
        v.acctId = i;
        g(o,v);
      };

      g.clearUserCookie = function(c, d, i) {
        if (!c || document.cookie.match("fs_uid=[`;`]*`[`;`]*`[`;`]*`")) {
          d = n.domain;

          while (1) {
            n.cookie = oneLineTrim`
              fs_uid=;domain=${d};path=/;expires=${new Date(0).toUTCString()}
            `;
            i = d.indexOf(".");

            if (i < 0) {
              break;
            }

            d = d.slice(i + 1);
          }
        }
      };
  })(
    window,
    document,
    window["_fs_namespace"],
    "script",
    "user",
  );

  const identificationData = {};

  if (AuctionEx.tenantId) {
    identificationData.tenant_str = AuctionEx.tenantId;
  }

  if (AuctionEx.user) {
    const {
      user: {
        email,
        name,
      },
    } = AuctionEx;

    identificationData.displayName = name;
    identificationData.email = email;
  }

  FS.identify(
    // FIXME: Try to uniquely identify guests.
    AuctionEx.user ? AuctionEx.user.id : "guest",
    identificationData,
  );

  // Enable self-XSS warnings if in production and in the front-end.
  // `window.console.log` will NOT get stripped at minification time.
  // FIXME: Add a way to opt out of this, for power users and developers.
  if (typeof window !== "undefined") {
    window.console.log(
      `%c${__("warning").toUpperCase()}`,
      "color:yellow; background:red; font-size: 16pt",
    );
    window.console.log(__("selfXss"));
  }
}

// Google analytics if a tracking code is provided.
// Taken from:
// https://github.com/webpack/analyse/blob/8d7c9d7047b08e329638cb00aee66facf7efae28/app/googleAnalytics.js
if (typeof GA_TRACKING_CODE !== "undefined") {
  (function(window, document, script, url, r, tag, firstScriptTag) {
    window.GoogleAnalyticsObject = r;
    window[r] = window[r] || ((...args) => {
      (window[r].q = window[r].q || []).push(args);
    });
    window[r].l = 1 * new Date();
    tag = document.createElement(script);
    firstScriptTag = document.getElementsByTagName(script)[0];
    tag.async = 1;
    tag.src = url;
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }(
    window,
    document,
    "script",
    "//www.google-analytics.com/analytics.js",
    "ga",
  ));

  const {ga} = window;

  ga("create", GA_TRACKING_CODE, GA_TRACKING_CONFIG);
  ga("send", "pageview");
}



// WEBPACK FOOTER //
// ./all.js